import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const Phase1Permissions: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/linkosx-phase1-permissions.excalidraw"
    title="LinkOSx Phase 1 — Configured Business Builder Modules"
    subtitle="8 configured business builder modules and their required permissions for view, create, edit, and delete access."
  />
);

export default Phase1Permissions;
